import { fetchRecommendationSuggestions } from 'actions/SearchActions'
import { Experiments } from 'constants/optimizely'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useExperiment from 'hooks/Optimizely/useExperiment'
import { getSearchedPlaces, getSearchedPlacesByPopularity } from 'lib/search/searchedPlaces'
import { useEffect } from 'react'

const MAX_PLACE_IDS = 3
const emptyArray: Array<App.SearchItemV3> = []

function getPlaceIdsForVariant(variation: string | undefined): Array<string> {
  if (variation === 'most_searched') {
    return getSearchedPlacesByPopularity({ excludeAnywhere: true })
      .slice(0, MAX_PLACE_IDS)
      .map(p => p.placeId)
  }
  if (variation === 'most_recent') {
    return getSearchedPlaces({ excludeAnywhere: true })
      .slice(0, MAX_PLACE_IDS)
      .map(p => p.placeId)
  }
  return []
}

function useRecommendationSuggestions(): Array<App.SearchItemV3> {
  const dispatch = useAppDispatch()
  const { variation } = useExperiment(Experiments.searchRecommendationSuggestions)

  const placeIds = getPlaceIdsForVariant(variation)
  const key = placeIds.join(',')

  useEffect(() => {
    if (key) {
      dispatch(fetchRecommendationSuggestions(key.split(',')))
    }
  }, [dispatch, key])

  const suggestions = useAppSelector(state =>
    key ? state.search.recommendationSuggestions[key] : undefined,
  )

  return suggestions ?? emptyArray
}

export default useRecommendationSuggestions
